export const IPO_STATUS = {
  OPEN: 'O',
  CONFIRMED_F: 'F',
  CONFIRMED_D: 'D',
  CLOSED: 'C',
  ACCEPTED_H: 'H',
  ACCEPTED_I: 'I',
  ACCEPTED_W: 'W',
  CANCELLED: 'X'
}